export function downloadBookingsOrgTypePatcher(data) {
    return {
        __typename: 'DownloadBookingsQuery',
        ...data,
        occupancyBookings: {
            __typename: 'DownloadBookingsQueryUrl',
            ...data.occupancyBookings,
        },
    };
}
